import React, { useRef } from 'react';
import { motion, useMotionValue, useSpring, useReducedMotion } from 'framer-motion';

// Subtle 3D tilt toward the cursor. Desktop pointer only, honors reduced-motion.
const Tilt = ({ children, max = 6, className = '' }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const rx = useMotionValue(0);
  const ry = useMotionValue(0);
  const srx = useSpring(rx, { stiffness: 190, damping: 16, mass: 0.6 });
  const sry = useSpring(ry, { stiffness: 190, damping: 16, mass: 0.6 });

  if (reduce) return <div className={className}>{children}</div>;

  const onMove = (e) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    ry.set(px * max * 2);
    rx.set(-py * max * 2);
  };
  const onLeave = () => { rx.set(0); ry.set(0); };

  return (
    <div className={className} style={{ perspective: 900 }}>
      <motion.div ref={ref} style={{ rotateX: srx, rotateY: sry, transformStyle: 'preserve-3d' }}
        onMouseMove={onMove} onMouseLeave={onLeave}>
        {children}
      </motion.div>
    </div>
  );
};

export default Tilt;
